var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11219_16252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4917 32.5918C25.3283 32.5918 32.4917 25.4284 32.4917 16.5918C32.4917 7.75524 25.3283 0.591797 16.4917 0.591797C7.65514 0.591797 0.491699 7.75524 0.491699 16.5918C0.491699 25.4284 7.65514 32.5918 16.4917 32.5918Z",
    fill: "url(#paint0_linear_11219_16252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81289 16.2454L23.2396 10.2974C23.9556 10.0387 24.5809 10.4721 24.3489 11.5547L24.3502 11.5534L21.7236 23.9281C21.5289 24.8054 21.0076 25.0187 20.2782 24.6054L16.2782 21.6574L14.3489 23.5161C14.1356 23.7294 13.9556 23.9094 13.5422 23.9094L13.8262 19.8387L21.2396 13.1414C21.5622 12.8574 21.1676 12.6974 20.7422 12.9801L11.5809 18.7481L7.63156 17.5161C6.77423 17.2441 6.75556 16.6587 7.81289 16.2454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11219_16252",
    x1: 4.51197,
    y1: 1.21913,
    x2: 33.8616,
    y2: 24.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11219_16252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.491699 0.591797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBot);
export default __webpack_public_path__ + "static/media/telegram_bot.aa5962f4df3e90320219e1dfc6f67fae.svg";
export { ForwardRef as ReactComponent };